import { render, staticRenderFns } from "./BenchmarkRules.vue?vue&type=template&id=8c494cb8&scoped=true"
import script from "./BenchmarkRules.vue?vue&type=script&lang=ts"
export * from "./BenchmarkRules.vue?vue&type=script&lang=ts"
import style0 from "./BenchmarkRules.vue?vue&type=style&index=0&id=8c494cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c494cb8",
  null
  
)

export default component.exports